import React from 'react';

export default class Col extends React.Component {

  // constructor(props) {
  //   super(props);
  //
  //   // this.state = {
  //   //   data : [],
  //   //   value: 'coconut',
  //   //   toDo: true,
  //   // };
  // }

  render() {

    var cls = (this.props.centered === 'true') ? 'blk-form-column-centered':'blk-form-column-left';
    return (
        <div className={cls} style={this.props.style}>{this.props.children}</div>
    )
  }
}
